export default "/assets/aa3bafd3e1ee092a.svg"